<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<div class="eq5-range-container-valid">
  <div
    class="information-panel"
    [ngStyle]="{
      'justify-content': question.useValidatedSlider
        ? 'center'
        : 'space-between'
    }"
  >
    <div *ngIf="!question.useValidatedSlider" class="range-info">
      {{ question.endLabel }}
    </div>

    <div
      *ngIf="question.displayValue"
      [ngClass]="
        question.useValidatedSlider
          ? 'value-displayer-valid'
          : 'value-displayer'
      "
    >
      <div class="eq5-h4 displayer-title">
        {{ 'EQ5.YOUR_HEALTH_TODAY' | translate }}
        <span *ngIf="question.useValidatedSlider">=</span>
      </div>
      <div class="displayer-value">
        <div class="eq5-div">{{ value }}</div>
      </div>
    </div>

    <div *ngIf="!question.useValidatedSlider" class="range-info">
      {{ question.startLabel }}
    </div>
  </div>

  <div class="range-panel">
    <div *ngIf="question.useValidatedSlider" class="range-info">
      {{ question.endLabel }}
    </div>

    <div class="slider-cont" (focusin)="focusin($event)">
      <div
        class="slider-wrapper"
        [ngStyle]="{ height: question.useValidatedSlider ? '50vh' : '65vh' }"
      >
        <form [formGroup]="formGroup">
          <input
            [class.bp-rtl]="document.dir === 'rtl'"
            [formControlName]="question.key"
            [class.hiddenThumb]="!value"
            [ngClass]="
              question.useValidatedSlider
                ? 'valid-color valid-height'
                : 'non-valid-height'
            "
            class="vertical reset-range eq5-thumb"
            type="range"
            (change)="onChange()"
            (input)="onInput($event)"
          />
        </form>
        <div
          class="eq5d-values"
          [ngClass]="
            question.useValidatedSlider
              ? 'slider-values-valid'
              : 'slider-values'
          "
        >
          <div>{{ question.maxValue }}</div>
          <div *ngIf="question.useValidatedSlider">
            {{ (question.maxValue + question.minValue) / 2 }}
          </div>
          <div>{{ question.minValue }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="question.useValidatedSlider" class="range-info">
      {{ question.startLabel }}
    </div>
  </div>
</div>
